"use strict";
// Copyright (c) StrangeBee 2023
Object.defineProperty(exports, "__esModule", { value: true });
const __1 = require("..");
class ObservableTypeController extends __1.ParentController {
    constructor() {
        super(...arguments);
        this.endpoints = {
            create: '/v1/observable/type',
            delete: '/v1/observable/type/:objectId',
        };
    }
    edit({}) {
        throw new Error('Cannot edit observable types!');
    }
}
exports.default = ObservableTypeController;
